module.exports = __webpack_public_path__ + "static/img/asada.dcf80b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/asada.jpg
// module id = go/h
// module chunks = 1